import { Injectable } from '@angular/core';
import { API } from '@core/services/api.base';
import { Observable } from 'rxjs';
import { UserProfile } from 'src/app/models/user-profile.model';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService extends API {
  
  checkUserExists(phoneNumber: string): Observable<UserProfile | null> {
    return this.get<UserProfile | null>(`v1/user/profile/phone/${phoneNumber}`);
  }
  findStoreUserProfile(phoneNumber: string, storeId: string): Observable<UserProfile | null> {
    return this.get<UserProfile | null>(`v1/business-user-profile/phone/${phoneNumber}/store/${storeId}`);
  }

  createGuestProfile(data: {
    phoneNumber: string;
    displayName: string;
    email?: string;
    userId?: string;  // Optional Firebase user ID (if already verified)
  }): Observable<{ userId: string }> {
    return this.post<{ userId: string }, any>(
      'v1/user/profile/guest',
      data
    );
  }
  createStoreUserProfile(data: {
    phoneNumber: string;
    displayName: string;
    storeId: string;
  }): Observable<UserProfile> {
    return this.post<UserProfile, any>(
      `v1/business-user-profile/guest/${data.storeId}`,
      data
    );
  }

  updateUserProfile(userId: string, updates: Partial<UserProfile>): Observable<UserProfile> {
    // Match mobile app API: use v1/user/profile without userId in URL
    // The backend determines the user from the auth token
    return this.put<UserProfile, Partial<UserProfile>>(
      `v1/user/profile`,
      updates
    );
  }

  linkUserProfileViaEmail(
    sessionCode: string,
    email: string,
    phoneNumber: string
  ): Observable<{
    documentId: string;
    emailDocumentId: string;
    sessionCode: string;
    email: string;
    method: string;
    userProfileId: string;
  }> {
    return this.post<
      {
        documentId: string;
        emailDocumentId: string;
        sessionCode: string;
        email: string;
        method: string;
        userProfileId: string;
      },
      { sessionCode: string; email: string; phoneNumber: string }
    >('v1/user/profile/link-email', { sessionCode, email, phoneNumber });
  }

  confirmLinkUserProfileViaEmail(
    sessionCode: string,
    otp: string,
    notificationId: string
  ): Observable<null> {
    return this.post<null, { sessionCode: string; otp: string; notificationId: string }>(
      'v1/user/profile/link-confirm',
      {
        sessionCode,
        otp,
        notificationId,
      }
    );
  }

  cancelLinkUserProfileViaEmail(notificationId: string): Observable<null> {
    return this.post<null, { notificationId: string }>(
      'v1/user/profile/link-cancel',
      { notificationId }
    );
  }

  completeLinkUserProfileViaEmail(
    sessionCode: string,
    userProfileId: string
  ): Observable<null> {
    return this.post<null, { sessionCode: string; userProfileId: string }>(
      'v1/user/profile/link-complete',
      {
        sessionCode,
        userProfileId,
      }
    );
  }
}
